import CalendarOffSvg from '@assets/images/svg/calendar-off.svg';
import React from 'react';
import { View } from 'react-native';

export interface CalendarOffIconProps {
  size?: number;
  /** Defaults to original Figma stroke (#333333). */
  color?: string;
}

export function CalendarOffIcon({
  size = 71,
  color = '#333333',
}: Readonly<CalendarOffIconProps>) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CalendarOffSvg width={size} height={size} color={color} />
    </View>
  );
}

export default CalendarOffIcon;
